var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app-tip" }, [
    _c(
      "div",
      { staticClass: "close", on: { click: _vm.close } },
      [_c("Icon", { attrs: { size: 19 } }, [_vm._v("tubiaoguifan2")])],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "logo" }, [
      _c("img", { staticClass: "logo_img", attrs: { src: _vm.imgLogo } }),
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "open", on: { click: _vm.openApp } }, [
      _vm._v("打开APP"),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text" }, [
      _c("div", { staticClass: "title" }, [_vm._v("苏打爱生活")]),
      _vm._v(" "),
      _c("div", { staticClass: "subTitle" }, [_vm._v("轻管理，享福利")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }